(function($){

setTimeout(function(){
	var submenu = $('#main-nav:not(.main-nav--is-mobile) .submenu');
	submenu.css('display', 'flex');
}, 500);
	
})(jQuery);